import React from "react";

export const AccountDetailsTabs = ({ onChange, selectedView }) => {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <div
        onClick={() => onChange("details")}
        className={`px-3 py-2 rounded-2xl cursor-pointer text-sm font-semibold ${
          selectedView === "details" ? "bg-gray50 text-gray700" : "text-gray500"
        }`}
      >
        My details
      </div>
      <div
        onClick={() => onChange("plan")}
        className={`px-3 py-2 rounded-2xl cursor-pointer text-sm font-semibold ${
          selectedView !== "details" ? "bg-gray50 text-gray700" : "text-gray500"
        }`}
      >
        Plan
      </div>
    </div>
  );
};
